import { Box, CardContent } from '@mui/material';
import AppSingleStat from './AppSingleStat';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import WidgetWrapper from './wrappers/WidgetWrapper';
export default function AppWidgetStats({
    displayedStats,
    title,
    sx,
    ...other
}) {
    const navigate = useNavigate();
    const handleArrowClick = (path) => {
        //ex. path = '/app/merchants'
        navigate(path);
    };
    const stats =
        displayedStats.length > 3 ? displayedStats.slice(0, 3) : displayedStats;
    return (
        <WidgetWrapper title={title}>
            <CardContent
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2.5
                }}
            >
                {stats.map((statItem) => (
                    <AppSingleStat
                        key={statItem.title}
                        {...statItem}
                        onArrowClick={() => handleArrowClick(statItem.path)}
                    />
                ))}
            </CardContent>
            <Box
                sx={{
                    bgcolor: (theme) => theme.palette.background.neutralGrey,
                    borderTop: (theme) => `solid 1px ${theme.palette.divider}`,
                    padding: 2.5
                }}
            >
                {/*<AppReport*/}
                {/*    title={i18n.t('text.monthlyReport')}*/}
                {/*    subtitle={i18n.t('text.monthlyReportSubtitle')}*/}
                {/*/>*/}
            </Box>
        </WidgetWrapper>
    );
}

AppWidgetStats.defaultProps = {
    title: '',
    displayedStats: []
};

AppWidgetStats.propTypes = {
    title: PropTypes.string,
    displayedStats: PropTypes.arrayOf(
        PropTypes.shape({
            path: PropTypes.string,
            title: PropTypes.string,
            subtitle: PropTypes.string,
            total: PropTypes.number,
            gradient: PropTypes.string
        })
    ),
    sx: PropTypes.object
};
